import { GuxFormFieldRadio, GuxTruncate } from "genesys-spark-components-react";
import { ReadOnlyRadio } from "features/common/ReadOnlyInput";
import { MarkdownInline } from "features/common/Markdown";
import "./MCQOptionRadioInput.less";

export function MCQOptionRadioInput({
    answerOptionId,
    selected,
    disabled,
    onSelected,
    text,
    type,
    ariaDescribedBy,
}: {
    answerOptionId: string;
    selected: boolean;
    disabled: boolean;
    onSelected: (s: string) => void;
    text: string | undefined;
    type: string;
    ariaDescribedBy?: string;
}) {
    return disabled ? (
        <ReadOnlyRadio checked={selected} label={text} />
    ) : (
        <GuxFormFieldRadio>
            <input
                slot="input"
                type="radio"
                id={answerOptionId}
                checked={selected}
                onChange={({ target }) => onSelected(target.id)}
                aria-describedby={ariaDescribedBy}
            />
            <label
                slot="label"
                htmlFor={answerOptionId}
                className={`${type}-answer-option-label`}
            >
                <GuxTruncate max-lines={15}>
                    <MarkdownInline
                        markdownInlineText={text ?? ""}
                    ></MarkdownInline>
                </GuxTruncate>
            </label>
        </GuxFormFieldRadio>
    );
}
